import { cx } from '@twind/core';

export default function RightArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cx('ostro-right-arrow-icon', className)}
      data-testid="right-arrow-icon"
    >
      <path
        d="M19 12L14.3163 7L13.3644 8.00001L16.4495 11.2935L5 11.2935L5 12.7065L16.4495 12.7065L13.3644 16L14.3163 17L19 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
